import { prefixObjectValues } from '../utils';

const addLayout = {
  grid: 'grid',
  card: 'card',
  addMultiBtn: 'all-multi-btn',
  addBtn: 'add-btn',
  addNewBtn: 'add-new-btn',
  cancelBtn: 'cancel-btn',
};

export default prefixObjectValues(addLayout, 'add-board-certs-layout');
